// AR
export const calendarsChatbotHc = {
  monthlyCalendar: {
    pricesTitle: "التسعير الديناميكي",
    prices: "الأسعار",
    noPropertiesAvailable: "لا توجد عقارات متاحة",
    noPropertiesFound: "لم يتم العثور على عقارات",
    minStayShort: "الحد الأدنى {n} ليلة",
    available: "متاح",
    closed: "مغلق",
    loading: "جارٍ التحميل…",
    showMoreMonths: "عرض المزيد من الأشهر",
    from: "من",
    to: "إلى",
    nightsLabelOne: "{n} ليلة",
    nightsLabelMany: "{n} ليلة",
    whatToDo: "ماذا تريد أن تفعل؟",
    close: "إغلاق",
    open: "فتح",
    price: "السعر",
    minStay: "الحد الأدنى للإقامة",
    closeReasonPlaceholder: "سبب الإغلاق (اختياري)",
    openHint: "سيُعاد فتح التواريخ المحددة (سيُزال الحظر).",
    nightsWord: "ليالٍ",
    clearSelection: "مسح التحديد",
    past: "منتهية",
    guestOne: "ضيف",
    guestMany: "ضيوف",
    perNight: "/ ليلة",
    noName: "بدون اسم",
    channelDirect: "مباشرة",
    ownerBlockComment: "حظر من قبل المالك",
    prepTime: "وقت التحضير",
    sameDayCutoff: "إغلاق في نفس اليوم",
    linkedClosed: "بيع كامل",
    linkedClosedInfo: "مغلق بسبب بيع الشقة كاملة ({motivo}). سيُفتح تلقائياً إذا أُلغي ذلك الحجز أو تغيّرت تواريخه.",
    alsoLinked: "مغلق أيضاً بسبب بيع الشقة كاملة ({motivo})",
    applyClose: "إغلاق التواريخ",
    applyOpen: "فتح التواريخ",
    applyPrice: "حفظ السعر",
    applyMinStay: "حفظ الحد الأدنى للإقامة",
    apply: "تطبيق",
    processing: "جارٍ المعالجة…",
    closingDates: "جارٍ إغلاق التواريخ…",
    openingDates: "جارٍ فتح التواريخ…",
    priceModeLabel: "طريقة السعر",
    priceModeFixed: "ثابت",
    priceModePercent: "٪",
    priceModeAmount: "مبلغ",
    percentPlaceholder: "مثال 20",
    amountPlaceholder: "مثال 10",
    percentHint: "تُحتسب كل ليلة من سعرها. بعلامة − ينخفض.",
    amountHint: "يُضاف إلى سعر كل ليلة الحالي. بعلامة − ينخفض.",
    invalidPrice: "أدخل سعرًا صالحًا.",
    changingPrice: "جارٍ تغيير السعر لكل ليلة…",
    priceUpdated: "تم تحديث السعر بنجاح.",
    priceUpdateError: "تعذّر تحديث السعر.",
    minStayMin: "يجب أن يكون الحد الأدنى للإقامة ليلة واحدة على الأقل.",
    changingMinStay: "جارٍ تغيير الحد الأدنى للإقامة…",
    minStayUpdated: "تم تحديث الحد الأدنى للإقامة بنجاح.",
    minStayUpdateError: "تعذّر تحديث الحد الأدنى للإقامة.",
    unknownError: "خطأ غير معروف",
  },
  calendar: {
    channelDirect: "مباشرة",
    searchMin2: "اكتب حرفين على الأقل للبحث",
    searchNoResults: "لم يتم العثور على حجوزات لهذا البحث",
    searchError: "خطأ أثناء البحث عن الحجوزات",
    processing: "جارٍ المعالجة…",
    ownerBlockComment: "حظر من قبل المالك",
    cutoffTip: "إغلاق البيع في نفس اليوم عند الساعة {time}",
    nightsLabelOne: "{n} ليلة",
    nightsLabelMany: "{n} ليلة",
    turnoverBefore: "وقت التحضير: احجب {nights} قبل كل وصول",
    turnoverAfter: "وقت التحضير: احجب {nights} بدءًا من كل مغادرة",
    turnoverBoth: "وقت التحضير: احجب {nights} قبل الوصول وبدءًا من المغادرة",
    selectAtLeastOneProperty: "اختر عقارًا واحدًا على الأقل.",
    selectAtLeastOneDate: "اختر تاريخًا فعليًا واحدًا على الأقل لتطبيق التغييرات.",
    preparingOps: "جارٍ تحضير {total} عملية...",
    applyingOps: "جارٍ تطبيق {index} من {total}: {name}",
    unknownError: "خطأ غير معروف",
    couldNotSaveChanges: "تعذّر حفظ التغييرات.",
    bulkApplyError: "تعذّر تطبيق التغييرات الجماعية. {message}",
    opsApplied: "تم تطبيق {success} من {total} عملية.",
    opsSkipped: "تم تخطي {skipped} تاريخًا يحتوي على حجوزات مؤكدة.",
    opsFailed: "فشلت {failed} عملية.",
    bulkApplied: "تم تطبيق التعديل الجماعي على {count} عقارًا.",
    couldNotOpenDate: "تعذّر فتح التاريخ",
    datesOpened: "تم فتح التواريخ",
    closeUpdated: "تم تحديث الإغلاق",
    todayLabel: "اليوم",
    closed: "مغلق",
    linkedClosed: "بيع كامل",
    linkedClosedInfo: "مغلق بسبب بيع الشقة كاملة ({motivo}). سيُفتح تلقائياً إذا أُلغي ذلك الحجز أو تغيّرت تواريخه.",
    alsoLinked: "مغلق أيضاً بسبب بيع الشقة كاملة ({motivo})",
    closingDates: "جارٍ إغلاق التواريخ…",
    couldNotCloseDates: "تعذّر إغلاق التواريخ",
    clearFiltersTitle: "مسح عوامل التصفية",
    noPropertiesAvailable: "لا توجد عقارات متاحة",
    noPropertiesFound: "لم يتم العثور على عقارات",
    dynamicPricesTitle: "التسعير الديناميكي",
    prices: "الأسعار",
    viewWide: "عرض واسع",
    viewCompact: "عرض مضغوط",
    viewNormal: "عرض عادي",
    viewFull: "عرض كامل",
    searchBookingTitle: "البحث عن حجز",
    searchBookingPlaceholder: "البحث عن حجز…",
    search: "بحث",
    resultsSelectOne: "{count} نتيجة — اختر واحدة:",
    bulkEdit: "تعديل جماعي",
    goToTodayTitle: "الذهاب إلى اليوم",
    showHeader: "إظهار الترويسة",
    configArrivalDeparture: "تكوين قواعد الوصول والمغادرة",
    notAvailable: "غير متاح",
    extension: "تمديد",
    lateCheckoutUntil: "مغادرة متأخرة حتى {time}",
    aiRequests: "الاستقبال بالذكاء الاصطناعي",
    guestComments: "ملاحظات الضيف",
    internalNotes: "ملاحظات داخلية",
    extrasTitle: "الإضافات المشتراة",
    extrasPending: "بانتظار التأكيد",
    reqArrivalTitle: "وقت الوصول",
    reqAt: "الساعة {time}",
    reqUntil: "حتى {time}",
    reqNights: "ليالٍ إضافية: {n}",
    reqPending: "قيد الانتظار",
    reqConfirmed: "مؤكد",
    reqPaid: "مدفوع",
    reqOffered: "معروض",
    reqPrioritised: "ذو أولوية",
    pendingAmount: "المتبقي:",
    noticesColumn: "تنبيهات",
    callsTitle: "المكالمات",
    callsCount: "المكالمات: {n}",
    extensionPaid: "تم دفع التمديد",
    listCheckin: "الوصول",
    listCheckout: "المغادرة",
    priceOriginal: "الحجز الأصلي",
    priceExtension: "التمديد",
    priceTotal: "الإجمالي",
    paymentInProcess: "الدفع قيد المعالجة",
    overbooking: "الحجز الزائد",
    noAccommodationsFound: `لم يتم العثور على عقارات مطابقة لـ "{term}".`,
    past: "منتهية",
    paymentInProcessLower: "الدفع قيد المعالجة",
    pendingApproval: "بانتظار الموافقة",
    pendingApprovalTitle: "بانتظار الموافقة",
    guestOne: "ضيف",
    guestMany: "ضيوف",
    perNight: "/ ليلة",
  },
  tableFilters: {
    filterByDate: "التصفية حسب التاريخ من - إلى",
    filterByCountry: "التصفية حسب البلد",
    all: "الكل",
    countrySpain: "إسبانيا",
    countryColombia: "كولومبيا",
    countryBrazil: "البرازيل",
    filterByState: "التصفية حسب الحالة",
    allStates: "كل الحالات",
    stateDemo: "النسخة التجريبية",
    stateSubscribed: "المشتركون",
    stateNotSubscribed: "غير مشتركين",
    searchRecords: "البحث في السجلات",
  },
  chatbotPageIndex: {
    aiAgentBadge: "وكيل الذكاء الاصطناعي",
    planFeatureHint: "هذه الميزة متاحة مع خطة مدفوعة.",
    otaAgentTitle: "وكيل الذكاء الاصطناعي لمنصات OTA",
    otaAgentHint: "فعّله ليرد الوكيل تلقائيًا على رسائل Booking وAirbnb ومنصات OTA الأخرى.",
    otaRequiresWhatsapp: "يتطلب تفعيل وكيل الذكاء الاصطناعي على WhatsApp.",
    guardNotice: "عند تعطيل وكيل الذكاء الاصطناعي، تتحول الدردشة أيضًا إلى <strong>الرد اليدوي</strong> تلقائيًا. ستظل مفاتيح كل محادثة مقفلة حتى تعيد تفعيله.",
    configureBasic: "تكوين وكيل الذكاء الاصطناعي الأساسي",
    configureAdvanced: "تكوين وكيل الذكاء الاصطناعي المتقدم",
    comingSoon: "قريبًا",
    detailFallback: "التفاصيل",
    errorLoadListingConfig: "تعذّر تحميل إعدادات القائمة",
    errorSaveChange: "خطأ أثناء حفظ التغيير",
    otaAgentActivated: "تم تفعيل وكيل الذكاء الاصطناعي لمنصات OTA",
    otaAgentDeactivated: "تم إيقاف وكيل الذكاء الاصطناعي لمنصات OTA",
  },
  chatbotIndex: {
    accommodationFallback: "العقار",
    defaultHandoffSupportLine: "\nإذا كنت بحاجة إلى مساعدة سريعة، تواصل معنا على {phone} 📞",
    defaultHandoffMessage: "مرحبًا 😊 لا تتوفر لديّ هذه المعلومة حاليًا، لكن أحد أعضاء فريقنا سيخدمك قريبًا 🙌{suffix}\nنحن معك طوال فترة إقامتك! 🏡✨",
    silentModeMessage: "لن يتم إرسال رد تلقائي إلى الضيف. سيستمر النظام في إشعار المشغّل ليتمكن من متابعة المحادثة.",
    statusNoGuestReply: "بدون رد على الضيف",
    statusUsingCustom: "يستخدم رسالة مخصصة",
    statusUsingDefault: "يستخدم الرسالة الافتراضية",
    helperSilent: "لن يتلقى الضيف ردًا تلقائيًا عندما لا يعرف وكيل الذكاء الاصطناعي ماذا يجيب، لكن سيتلقى المشغّل الإشعار لتولي المحادثة.",
    helperCustom: "سيترجم النظام هذه الرسالة المخصصة تلقائيًا إلى لغة الضيف.",
    helperHasCustom: "لديك رسالة مخصصة محفوظة، لكن سيستمر النظام حاليًا في استخدام الرسالة الافتراضية.",
    helperDefault: "إذا أنشأت رسالة رئيسية، يمكنك تفعيلها هنا وسيترجمها النظام تلقائيًا إلى لغة الضيف.",
    sourceSilent: "صامت",
    sourceCustom: "مخصص",
    sourceDefault: "افتراضي",
    defaultBotName: "مساعدي الافتراضي",
    errorLoadBotName: "تعذّر تحميل اسم المساعد.",
    errorLoadHandoff: "تعذّر تحميل رسالة التحويل.",
    botNameUpdated: "تم تحديث اسم المساعد.",
    errorSaveBotName: "تعذّر حفظ اسم المساعد.",
    masterMessageUpdated: "تم تحديث الرسالة الرئيسية.",
    errorSaveMaster: "تعذّر حفظ الرسالة الرئيسية.",
    warnCreateCustomFirst: "أنشئ رسالة مخصصة أولًا قبل تفعيلها.",
    modeCustomActivated: "سيتم الآن استخدام الرسالة المخصصة.",
    modeSilentActivated: "سيبقى البوت صامتًا عندما لا يعرف كيف يجيب، لكن سيظل المشغّل يتلقى الإشعار.",
    modeDefaultActivated: "سيتم الآن استخدام الرسالة الافتراضية.",
    errorUpdateActiveMessage: "تعذّر تحديث الرسالة النشطة.",
    warnWriteQuestion: "اكتب سؤالًا قبل الحفظ.",
    questionCreated: "تم إنشاء السؤال بنجاح.",
    errorAddQuestion: "تعذّر إضافة السؤال.",
    botNamePlaceholder: "اسم المساعد",
    handoffRowTitle: "الرسالة عندما لا يعرف الوكيل كيف يجيب",
    customize: "تخصيص",
    expandAria: "توسيع",
    handoffSubtitle: "سيُرسل هذا النص عندما لا يجد وكيل الذكاء الاصطناعي الإجابة في الحقائق أو الذاكرة أو الأسئلة الشائعة.",
    modeDefaultTitle: "الرسالة الافتراضية",
    modeDefaultDesc: "يستخدم الرسالة القياسية للنظام مع رقم هاتف الدعم.",
    modeCustomTitle: "رسالة مخصصة",
    modeCustomDescActive: "فعّل النص المخصص الذي حفظته في النافذة.",
    modeCustomDescEmpty: "لم تنشئ رسالة مخصصة بعد.",
    modeSilentTitle: "عدم الرد على الضيف",
    modeSilentDesc: "لا يتلقى الضيف رسالة تلقائية، لكن سيتم إشعار المشغّل لمتابعة المحادثة.",
    loadingMessage: "جارٍ تحميل الرسالة...",
    masterMessage: "الرسالة الرئيسية",
    newQuestionTitle: "سؤال جديد",
    newQuestionSubtitle: "أنشئ سؤالًا شائعًا جديدًا ليتمكن وكيل الذكاء الاصطناعي من الإجابة عليه بدقة أكبر.",
    guestQuestionLabel: "سؤال الضيف",
    questionPlaceholder: "مثال: في أي ساعة يبدأ تسجيل الوصول؟",
    questionHelp: "نصيحة: اكتب السؤال كما يطرحه ضيف حقيقي.",
    cancel: "إلغاء",
    saveQuestion: "حفظ السؤال",
    handoffKicker: "رد التحويل",
    handoffModalTitle: "تخصيص الرسالة الرئيسية",
    handoffModalSubtitle: "اكتب رسالة واحدة بالإسبانية. سيترجمها النظام تلقائيًا ويرد وفقًا للغة التي يتحدث بها الضيف.",
    masterToolbarInfo: "يمكنك استخدام الرموز التعبيرية ونبرة ودّية، تمامًا كما في رسائلك التلقائية الأخرى.",
    emojiSearchPlaceholder: "ابحث عن رمز تعبيري...",
    masterTextareaPlaceholder: "اكتب الرسالة الرئيسية هنا. يمكنك استخدام الرموز التعبيرية ونبرة دافئة للضيف.",
    masterHint: "توصية: اكتب الرسالة بالإسبانية بالنبرة التي تريد إيصالها بالضبط. سيكيّفها النظام تلقائيًا مع لغة الضيف.",
    viewDefaultMessage: "عرض الرسالة الافتراضية",
    saveMessage: "حفظ الرسالة",
    newButton: "جديدة",
    emojiButton: "رمز تعبيري",
  },
  messageAccountDemo: {
    usingDemo: "أنت تستخدم النسخة التجريبية",
    ofThePlatform: "من المنصة",
    trialHave: "لا يزال لديك",
    trialDaysToEnjoy: "يومًا للاستمتاع بجميع الميزات!",
    trialSubscribeNow: "اشترك الآن وواصل إدارة عقاراتك دون انقطاع.",
    subscribeNowLabel: "اشترك الآن",
  },
};
